
import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import { useCategories } from "@/hooks/useCategories";
import { useEditReagent } from "@/hooks/useEditReagent";
import EditReagentForm from "@/components/reagents/EditReagentForm";

const EditReagentPage = () => {
  const navigate = useNavigate();
  const { categories } = useCategories();
  
  const {
    reagent,
    isLoading,
    error,
    formData,
    selectedImage,
    isSubmitting,
    handleChange,
    handleSelectChange,
    handleImageChange,
    handleSubmit,
    handleCancel
  } = useEditReagent();
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="container mx-auto py-8 flex-grow flex items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
        <Footer />
      </div>
    );
  }
  
  if (error || !reagent) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="container mx-auto py-8 flex-grow">
          <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
            <p className="text-red-600">Error loading reagent details. Please try again later.</p>
          </div>
          <Button onClick={() => navigate("/my-reagents")}>Back to My Reagents</Button>
        </div>
        <Footer />
      </div>
    );
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 flex-grow">
        <div className="mb-6">
          <Button 
            variant="outline" 
            onClick={() => navigate("/my-reagents")}
            className="mb-4"
          >
            ← Back to My Reagents
          </Button>
          <h1 className="text-2xl font-bold">Edit Reagent</h1>
        </div>
        
        <EditReagentForm
          formData={formData}
          reagent={reagent}
          selectedImage={selectedImage}
          isSubmitting={isSubmitting}
          categories={categories}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
          onImageChange={handleImageChange}
          onChange={handleChange}
          onSelectChange={handleSelectChange}
        />
      </div>
      
      <Footer />
    </div>
  );
};

export default EditReagentPage;
